/**
 * Что делать, когда переписка по заказу закрыта. Отменённый и завершённый заказ
 * не комментируют ни художник, ни заказчик: сообщение всё равно осталось бы без
 * ответа. Поэтому здесь только запасной контакт и подсказка начать новый заказ.
 */
export function ClosedOrderContact({
  email,
  who,
}: {
  email: string | null;
  who: 'Художник' | 'Заказчик';
}) {
  return (
    <div className="closed-contact">
      <strong>Заказ закрыт, переписка по нему больше не идёт.</strong>
      {email ? (
        <p>
          Написать можно на почту:{' '}
          <a href={`mailto:${email}`} className="link-inline">
            {email}
          </a>
        </p>
      ) : (
        <p className="muted">
          {who} не оставил почту. Если есть что обсудить — начните новый заказ.
        </p>
      )}
    </div>
  );
}
